import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=79ea7910&lang=pug&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports